import {
  ARTICLE_LISTE_SUCCES,
  ARTICLE_LISTE_ECHEC,
  ARTICLE_FAMILLE_SUCCES,
  ARTICLE_FAMILLE_ECHEC,
  ARTICLE_FAMILLE_RESET,
  ARTICLE_FAMILLE_REQUETTE,
  ARTICLE_DETAILS_SUCCES,
  ARTICLE_DETAILS_ECHEC,
  ARTICLE_DETAILS_RESET,
  ARTICLE_DETAILS_REQUETTE,
  ARTICLE_TOUT_SUCCES,
  ARTICLE_TOUT_ECHEC,
  ARTICLE_TOUT_RESET,
  EVALUATION_REQUETTE,
  EVALUATION_SUCCES,
  EVALUATION_ECHEC,
  ARTICLE_MARQUE_ECHEC,
  ARTICLE_MARQUE_SUCCES,
  ARTICLE_LISTE_ALL_SUCCES,
  ARTICLE_LISTE_ALL_ECHEC,
  ARTICLE_NV_CREE_REQUETTE,
  ARTICLE_NV_CREE_SUCCES,
  ARTICLE_NV_CREE_ECHEC,
  ARTICLE_LISTE_REQUETTE,
  ARTICLE_LISTE_PROMO_REQUETTE,
  ARTICLE_LISTE_PROMO_SUCCES,
  ARTICLE_LISTE_PROMO_ECHEC,
} from "../constantes/articlesConstantes";
export const articleNvCreerReducer = (state = { article: {} }, action) => {
  switch (action.type) {
    case ARTICLE_NV_CREE_REQUETTE:
      return { loading: true };
    case ARTICLE_NV_CREE_SUCCES:
      return { loading: false, succes: true, article: action.payload };
    case ARTICLE_NV_CREE_ECHEC:
      return { loading: false, erreur: action.payload };

    default:
      return state;
  }
};
export const articleListeReducer = (state = { articles: [] }, action) => {
  switch (action.type) {
    case ARTICLE_LISTE_REQUETTE:
      return { loading: true };
    case ARTICLE_LISTE_SUCCES:
      return { articles: action.payload, loading: false };
    case ARTICLE_LISTE_ECHEC:
      return { erreur: action.payload, loading: false };

    default:
      return state;
  }
};
export const articleListePromoReducer = (state = { articles: [] }, action) => {
  switch (action.type) {
    case ARTICLE_LISTE_PROMO_REQUETTE:
      return { loading: true };
    case ARTICLE_LISTE_PROMO_SUCCES:
      return { articles: action.payload, loading: false };
    case ARTICLE_LISTE_PROMO_ECHEC:
      return { erreur: action.payload, loading: false };

    default:
      return state;
  }
};
export const articleListeAllReducer = (state = { articles: [] }, action) => {
  switch (action.type) {
    case ARTICLE_LISTE_ALL_SUCCES:
      return { articles: action.payload };
    case ARTICLE_LISTE_ALL_ECHEC:
      return { erreur: action.payload };

    default:
      return state;
  }
};
export const articleFamilleReducer = (
  state = { articlesF: [], loading: false },
  action
) => {
  switch (action.type) {
    case ARTICLE_FAMILLE_REQUETTE:
      return { loading: true };
    case ARTICLE_FAMILLE_SUCCES:
      return { articlesF: action.payload, loading: false };
    case ARTICLE_FAMILLE_ECHEC:
      return { erreur: action.payload, loading: false };
    case ARTICLE_FAMILLE_RESET:
      return { articlesF: [], loading: false };
    default:
      return state;
  }
};

export const articleMarqueReducer = (state = { articlesM: [] }, action) => {
  switch (action.type) {
    case ARTICLE_MARQUE_SUCCES:
      return { articlesM: action.payload };
    case ARTICLE_MARQUE_ECHEC:
      return { erreur: action.payload };

    default:
      return state;
  }
};

export const articleDetailsReducer = (state = { article: {} }, action) => {
  switch (action.type) {
    case ARTICLE_DETAILS_REQUETTE:
      return { loading: true };
    case ARTICLE_DETAILS_SUCCES:
      return { article: action.payload, loading: false };
    case ARTICLE_DETAILS_ECHEC:
      return { erreur: action.payload, loading: false };
    case ARTICLE_DETAILS_RESET:
      return {};

    default:
      return state;
  }
};

export const articleSearchReducer = (state = { articles: [] }, action) => {
  switch (action.type) {
    case ARTICLE_TOUT_SUCCES:
      return { articles: action.payload };
    case ARTICLE_TOUT_ECHEC:
      return { erreur: action.payload };
    case ARTICLE_TOUT_RESET:
      return { articles: [] };
    default:
      return state;
  }
};
export const evaCreeReducer = (state = {}, action) => {
  switch (action.type) {
    case EVALUATION_REQUETTE:
      return { loading: true };
    case EVALUATION_SUCCES:
      return { loading: false, succes: true };
    case EVALUATION_ECHEC:
      return { loading: false, erreur: action.payload };
    default:
      return state;
  }
};
